import { Literals } from "shared/types";

export const getButtonDescriptors = (copyTexts: Literals) => [
  {
    value: true,
    label: copyTexts.yes,
    selectedOption: "liked",
    selectedBg: "bg-emerald-50",
    selectedText: "text-lime-600",
  },
  {
    value: false,
    label: copyTexts.no,
    selectedOption: "disliked",
    selectedBg: "bg-red-50",
    selectedText: "text-red-600",
  },
];
